import { css } from 'lit';
export const menuItem = css `
  .menu-item {
    position: relative;
    display: flex;
    align-items: center;
    -webkit-user-select: none;
    user-select: none;
    color: var(--primary-text-color);
    font-family: var(--font-family-monument);
    font-size: var(--font-size-xs);
    line-height: var(--line-height-looser);
    margin: 0.313rem; /* 5px */
    padding: 0.438rem 0.625rem; /* 7px 10px */
    min-height: 1.313rem; /* 45px incl margin and padding */
    border-radius: 0.375rem; /* 6px */
    cursor: pointer;
  }

  :host(:focus) .menu-item:not(.menu-item--selected) {
    background: var(--tertiary-background-color);
  }
`;
